<div class="h-[85vh] w-[100vw] flex flex-row">
  @if(imageLoaded){
  <div class="flex flex-col w-[60vw] h-[85vh] mx-[2vw] gap-[3vh] pt-[3vh]">
    <p-card>
      <app-toolbar (colorChange)="changeColor($event)" (drawingModeChange)="changeDrawingMode($event)"
                   (lineWidthChange)="changeLineWidth($event)" (circleRadiusChange)="changeCircleRadius($event)"
                   (triggerUndo)="undo()" (triggerRedo)="redo()" (onSave)="save()" [(historyIndex)]="this.historyIndex" [(canvasHistoryLength)]="this.canvasHistoryLength"/>
    </p-card>
    <p-card>
      <div class="h-[55vh] w-[60vw]">
      <app-canvas [base64ImageString]="base64ImageString" [annotationData]="getAnnotations()" [currentColor]="currentColor"
                  [drawingMode]="this.currentDrawingMode"
                  [circleRadius]="this.currentCircleRadius" [lineWidth]="currentLineWidth"
                  (drawnWithColor)="drawnWithColor($event)" (redoneWithColor)="redoneWithColor($event)"
                  (undoneWithColor)="undoneWithColor($event)" [(historyIndex)]="this.historyIndex" [(canvasHistoryLength)]="this.canvasHistoryLength"></app-canvas>
      </div>
    </p-card>
  </div>
  <div class="w-[40vw] h-[85vh] mx-[2vw] pt-[3vh]">
    <p-card>
      <ng-template #header>
        <div class="flex flex-row h-[4vh] w-[15vw] pl-[1vw] items-end justify-between text-2xl tracking-wider">
        {{'AnnotationLegend.Title'|translate}}
        </div>
      </ng-template>
      <app-annotation-legend [documentLegendElements]="getLegendElements()"></app-annotation-legend>
    </p-card>
  </div>
    }
</div>
